module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-watch-8eca7965ab77370858da4af2199ac64d.svg";